import actions from './actions';
import mutations from './mutations';

const settings = {
    namespaced: true,
    state: {
        configTypes: {
            admin: [],
            boss: []
        },
        items: []
    },
    mutations,
    actions
};

export default settings;
